import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'adc-profile',
  templateUrl: './adc-profile.component.html',
  styleUrls: ['./adc-profile.component.scss'],
  standalone: false
})
export class AdcProfileComponent implements OnChanges{
  @Input('breadcrumbData') breadcrumbData: any;
  @Input('profileData') profileData: any;
  @Input('profileTable') profileTable: any;
  @Input('language') language: any;
  @Input() inputStyle: any;
  @Output() activeClass: EventEmitter<any>;
  activeTab: string = 'tab1';

  constructor() {
    this.activeClass = new EventEmitter();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes && changes['profileData'].currentValue) {
      const data = changes['profileData'].currentValue;
      console.log(data, 'profile data');
    }
  }

  setActiveTab(tabName: string): void {
    this.activeClass.emit(this.activeTab);
    const parentElement = document.getElementById("org");
    if (parentElement) {
      const tabButtons = parentElement.querySelectorAll(".adc-tab-button") as NodeListOf<HTMLElement>;
      const tabContent = parentElement.querySelectorAll(".adc-tab-pane") as NodeListOf<HTMLElement>;

      tabContent.forEach((content: HTMLElement) => {
        content.classList.remove("active");
        if (content.getAttribute("data-tab-name") === tabName) {
          content.classList.add("active");
        }
      });

      tabButtons.forEach((btn: HTMLElement) => {
        btn.classList.remove("active");
        if (btn.getAttribute("data-tab-target") === tabName) {
          btn.classList.add("active");
        }
      });
    }
  }
}
